
import {
    USER_LOGIN,
    CHECK_USER_EXISTS,
    REGISTER_USER,
    SUCCESSFULL_REGISTRATION,
    FIREBASE_SIGNIN_GOOGLE,
    FIREBASE_SIGNIN_FACEBOOK,
    FIREBASE_SIGNIN_APPLE
} from "@/store/actions.type.js";
import { mapActions } from "vuex";
import alertModel from './../../components/Dialogs/alertModal.vue';
import Register from './../../components/register.vue'
import { announceValidationErrorsViaStatus } from '@/utils/formValidationAnnounce';

export default {
    components: { alertModel, Register },
    data () {
        return {
          isSignupClicked: true,
            email: "",
            postId: this.$route.params.id,
            password: null,
            singInLoading: true,
            fbLoading: true,
            googleLoading: true,
            appleLoading: true,
            isLogin: true,
            socialLoginObj: '',
            signupMethod: '',
            next: '',
            showAlert:false,
            alertMessage: null,
            formStatusMessage: ''
        };
    },
    created () {
        if(this.postId != 'signup'){
            this.isSignupClicked = false
        }
        if (this.$route.query && this.$route.query.next) {
            this.next = this.$route.query.next;
            localStorage.setItem('redirectpath', this.next);
        }
        if(this.$route.query.utm_source){
            localStorage.setItem('utmParams',window.location.href.split('?').pop());
            this.$toastr.Add({
                name: "disclaimer",
                msg: "“Anand Rathi Share & Stock Brokers Ltd does not provide investment advisory or online portfolio evaluation services. If a client is interested in portfolio evaluation services, they can avail of these services through William O’Neil India Pvt. Ltd. Any discrepancies/disputes will remain between a client & William O’Neil India Pvt. Ltd. Anand Rathi Share & Stock Brokers Ltd will not participate or be a party in any dispute.”",
                type: "info", // Toast type,
                position: "toast-top-full-width",
                clickClose: true, // Click Close Disable
                timeout: 0,
                showCloseButton: true,
              });
        }
    },
    computed: {
        userDetails () {
            return this.$store.state.authentication.user
        },
        isRedirectedBrokerUrl(){
          return (localStorage.getItem('utmParams')==undefined || localStorage.getItem('utmParams')==null
          || localStorage.getItem('utmParams') == 'utm_source=ARGuest' )?false:true;
        }
    },
    methods: {
        ...mapActions({
            usersignin: USER_LOGIN,
            checkuserexists: CHECK_USER_EXISTS,
            registeruser: REGISTER_USER,
            firebasegooglesignin: FIREBASE_SIGNIN_GOOGLE,
            firebasefacebooksignin: FIREBASE_SIGNIN_FACEBOOK,
            firebaseapplesignin: FIREBASE_SIGNIN_APPLE
        }),

        cancelModal (action) {
            this.showAlert = false;
        },

        popUpMsg(msg) {
            this.showAlert = true;
            this.alertMessage = msg;
        },

        announceFormValidationErrors() {
            announceValidationErrorsViaStatus(this, 'formStatusMessage', this.errors);
        },

        validateUser () {
            this.$validator.validateAll().then((result) => {
                if (result) {
                    this.userLogin()
                } else {
                    this.announceFormValidationErrors();
                }
            });
        },

        async userLogin () {
            var self = this;
            this.singInLoading = false;
            var userObj = { email: this.email, password: this.password }
            await this.usersignin(userObj).then(data => {
                if (data.response.success) {
                    if (localStorage.getItem('redirectpath')) {
                        this.$router.replace(this.$route.query.redirect || localStorage.getItem('redirectpath'));
                        localStorage.removeItem("redirectpath");
                    }
                    else if(this.isRedirectedBrokerUrl) {
                        self.$router.replace('/evaluation');
                    }
                    else {
                        self.$router.replace('/dashboard');
                    }
                } else {
                    if (data.response.providers && data.response.providers.length > 0) {
                        var providers = self.processProviders(data.response.providers);
                        this.$notify({
                            group: 'allAlerts',
                            title: '',
                            type: 'error',
                            text: '<div class="notificationBox"><span class="notificationIcon"><i class="font16 weight-500 pr-2 fa-error fa fa-times-circle" aria-hidden="true"></i></span> <span class="notificationText">' + data.response.message + '  ' + providers + ' </span></div>'
                        });
                    } else {
                        this.$notify({
                            group: 'allAlerts',
                            title: '',
                            type: 'error',
                            text: '<div class="notificationBox"><span class="notificationIcon"><i class="font16 weight-500 pr-2 fa-error fa fa-times-circle" aria-hidden="true"></i></span> <span class="notificationText">' + data.response.message + ' </span></div>'
                        });
                    }
                }
            });
            this.singInLoading = true;
        },
        processProviders (providers) {
            var isFaceBookAndGooglePresent = false;
            var arrayOfProviders = [];
            for (var i = 0; i < providers.length; i++) {
                if (providers[i].name == "Facebook" || providers[i].name == "Google") {
                    isFaceBookAndGooglePresent = true;
                }
                arrayOfProviders.push(providers[i].name);
            }
            if (isFaceBookAndGooglePresent) {
                return this.arrayRemove(arrayOfProviders, 'Facebook').join(", ");
            }

            return arrayOfProviders.join(", ");
        },
        arrayRemove (arr, value) {
            var value, a = arguments, L = a.length, ax;
            while (L > 1 && arr.length) {
                value = a[--L];
                while ((ax = arr.indexOf(value)) !== -1) {
                    arr.splice(ax, 1);
                }
            }
            return arr;
        },

        async googleSignIn () {
            this.googleLoading = false
            var self = this;
            await this.firebasegooglesignin().then(data => {
                if (data != null) {
                    self.socialLoginObj = data;
                    self.checkuserexists(self.socialLoginObj).then(data => {
                        if (!data.response.success) {
                            self.completeSocialRegistration('Google');
                        } else {
                            if (localStorage.getItem('redirectpath')) {
                                self.$router.replace(localStorage.getItem('redirectpath'));
                                localStorage.removeItem("redirectpath");
                            } else {

                                self.$router.replace('/dashboard');

                            }
                        }
                    });
                } else {
                    this.$notify({
                        group: 'allAlerts',
                        title: '',
                        type: 'error',
                        text: '<div class="notificationBox"><span class="notificationIcon"><i class="font16 weight-500 pr-2 fa-error fa fa-times-circle" aria-hidden="true"></i></span> <span class="notificationText"> Google Authentication Failed, Please try again! </span></div>'
                    });
                }
            });
            this.googleLoading = true
        },

        async facebookSignIn () {
            this.fbLoading = false
            var self = this;

            await this.firebasefacebooksignin().then(data => {
                if (data != null) {
                    if (data.email && data.email != undefined) {
                        self.socialLoginObj = data;
                        self.checkuserexists(self.socialLoginObj).then(data => {
                            if (!data.response.success) {
                                self.completeSocialRegistration('Facebook');
                            } else {
                                if (localStorage.getItem('redirectpath')) {
                                    self.$router.replace(localStorage.getItem('redirectpath'));
                                    localStorage.removeItem("redirectpath");
                                } else {

                                    self.$router.replace('/dashboard');

                                }
                            }
                        });
                    } else {
                        this.$notify({
                            group: 'allAlerts',
                            title: '',
                            type: 'error',
                            text: '<div class="notificationBox"><span class="notificationIcon"><i class="font16 weight-500 pr-2 fa-error fa fa-times-circle" aria-hidden="true"></i></span> <span class="notificationText"> Facebook Authentication Failed, Please try adding Your Email id in facebook and Retry! </span></div>'
                        });
                    }

                } else {
                    this.$notify({
                        group: 'allAlerts',
                        title: '',
                        type: 'error',
                        text: '<div class="notificationBox"><span class="notificationIcon"><i class="font16 weight-500 pr-2 fa-error fa fa-times-circle" aria-hidden="true"></i></span> <span class="notificationText"> Facebook Authentication Failed, Please try again! </span></div>'
                    });
                }
            });

            this.fbLoading = true
        },

        async appleSignIn () {
            this.appleLoading = false
            var self = this;

            await this.firebaseapplesignin().then(data => {
                if (data != null) {
                    if (data.email && data.email != undefined) {
                        self.socialLoginObj = data;
                        self.checkuserexists(self.socialLoginObj).then(data => {
                            if (!data.response.success) {
                                self.completeSocialRegistration('Apple');
                            } else {
                                if (localStorage.getItem('redirectpath')) {
                                    self.$router.replace(localStorage.getItem('redirectpath'));
                                    localStorage.removeItem("redirectpath");
                                } else {

                                    self.$router.replace('/dashboard');

                                }
                            }
                        });
                    } else {
                        this.$notify({
                            group: 'allAlerts',
                            title: '',
                            type: 'error',
                            text: '<div class="notificationBox"><span class="notificationIcon"><i class="font16 weight-500 pr-2 fa-error fa fa-times-circle" aria-hidden="true"></i></span> <span class="notificationText"> Apple Authentication Failed, Please try adding Your Email id in Apple login and Retry! </span></div>'
                        });
                    }
                } else {
                    this.$notify({
                        group: 'allAlerts',
                        title: '',
                        type: 'error',
                        text: '<div class="notificationBox"><span class="notificationIcon"><i class="font16 weight-500 pr-2 fa-error fa fa-times-circle" aria-hidden="true"></i></span> <span class="notificationText"> Apple Authentication Failed, Please try again! </span></div>'
                    });
                }
            });

            this.appleLoading = true;
        },

        completeSocialRegistration (signupMethod) {
            var self = this;
            self.socialLoginObj.password = null;
            self.socialLoginObj.country = "+91";
            self.socialLoginObj.refferal = "";
            self.socialLoginObj.mobile = "";
            self.socialLoginObj.deviceId = 1;
            self.socialLoginObj.emailConfirmed = true;
            self.socialLoginObj.phoneNumberConfirmed = true;
            self.socialLoginObj.phoneNumber = "";
            self.signupMethod = signupMethod;

            return self.registeruser(self.socialLoginObj).then(result => {
                if (result.data.response.success && result.data.response.token != "") {
                    return self.$store.dispatch(SUCCESSFULL_REGISTRATION, result.data.response).then(() => {
                        if (localStorage.getItem('redirectpath')) {
                            self.$router.replace(localStorage.getItem('redirectpath'));
                            localStorage.removeItem("redirectpath");
                        } else {
                            window.localStorage.setItem('signupMethod', self.signupMethod);
                            self.$router.replace('/dashboard');
                        }
                    });
                } else {
                    self.popUpMsg(result.data.response.message);
                }
            });
        }
    }
};



// WEBPACK FOOTER //
// ./src/assets/js/login.js